import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import styled from "styled-components";
import Box from "./Box";
var Centered = styled(Box).attrs(function(props) {
    return {
        $styles: _object_spread({
            textAlign: "center"
        }, props.$styles || {})
    };
})({});
export default Centered;
